import { getSettingsLT3 as getSettings, updateSettingsLT3 as updateSettings, setManualWinnerLT3 as setManualWinner } from "../../../helpers/apis";
import {
    fetchSettingsStart,
    fetchSettingsSuccess,
    fetchSettingsFailure,
    setLoading,
    setError,
} from "./reducer";

/**
 * Fetch current settings from API
 */
export const fetchSettingsData = () => async (dispatch) => {
    dispatch(fetchSettingsStart());
    dispatch(setLoading(true));

    try {
        const response = await getSettings();

        // Handle both response formats: {success: true, data: {...}} OR {status: 1, data: {...}}
        if (response?.success === true || response?.status === 1) {
            const settingsData = response.data || response;
            dispatch(fetchSettingsSuccess(settingsData));
        } else {
            const errorMessage = response?.message || "Failed to fetch settings";
            dispatch(fetchSettingsFailure(errorMessage));
        }
    } catch (err) {
        const errorMessage = err.message || "Network error occurred";
        dispatch(fetchSettingsFailure(errorMessage));
        dispatch(setError(errorMessage));
    } finally {
        dispatch(setLoading(false));
    }
};

/**
 * Update settings (mode, jackpot multiplier)
 */
export const updateSettingsAction = (data) => async (dispatch) => {
    dispatch(setLoading(true));

    try {
        const response = await updateSettings(data);

        // Handle both response formats
        if (response?.success === true || response?.status === 1) {
            const settingsData = response.data || response;
            dispatch(fetchSettingsSuccess(settingsData));
            return { success: true };
        } else {
            const errorMessage = response?.message || "Failed to update settings";
            dispatch(setError(errorMessage));
            return { success: false, error: errorMessage };
        }
    } catch (err) {
        const errorMessage = err.message || "Failed to update settings";
        dispatch(setError(errorMessage));
        return { success: false, error: errorMessage };
    } finally {
        dispatch(setLoading(false));
    }
};

/**
 * Declare manual winner
 */
export const declareManualWinner = (winningNumber) => async (dispatch) => {
    dispatch(setLoading(true));

    try {
        const response = await setManualWinner({ winningNumber });

        // Handle both response formats
        if (response?.success === true || response?.status === 1) {
            return { success: true, data: response.data };
        } else {
            const errorMessage = response?.message || "Failed to set manual winner";
            console.error("Manual winner failed:", errorMessage);
            dispatch(setError(errorMessage));
            return { success: false, error: errorMessage };
        }
    } catch (err) {
        console.error("Set manual winner error:", err);
        const errorMessage = err.message || "Failed to set manual winner";
        dispatch(setError(errorMessage));
        return { success: false, error: errorMessage };
    } finally {
        dispatch(setLoading(false));
    }
};
